import { Button, Spin } from "antd";
import styled from "styled-components";

export const Wrapper = styled.div<{ isOpen?: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 999999;
  justify-content: center;
  background: rgba(0,0,0,.7);
  display: ${({ isOpen }) => isOpen ? 'flex' : 'none' }
`;

export const CloseButton = styled(Button)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 99999999;
`;

export const Loader = styled(Spin)`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
`;
